export default (function (_ref) {
  var service = _ref.service,
    request = _ref.request;
  return {
    getHouseFacilitiesList: function getHouseFacilitiesList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/facility/get",
        method: "get",
        params: data
      });
    },
    addHouseFacility: function addHouseFacility() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/facility/add",
        method: "post",
        data: data
      });
    },
    updateHouseFacility: function updateHouseFacility() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/facility/update",
        method: "post",
        data: data
      });
    }
  };
});